import React from 'react';



export class TimerHiddenLanOver extends React.Component {



  render() {
    return (
      <div>
        <h1>{this.props.lanOverMessage}</h1>
        <h3> {this.props.lanOverSubMessage} </h3>
        <div className="row">

        
        </div>
      </div>
    )

  }
}



// WEBPACK FOOTER //
// ./src/Components/App/TimerHiddenLanOver.js